/**
 * Pure helpers for browser push (no network, no SDK) — split from webPush.js so they're
 * unit-tested without loading axios / Firebase.
 */

/** Firebase web config from the build environment, or null when web push isn't set up. */
export function webPushConfig(env = process.env) {
  const cfg = {
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    appId: env.REACT_APP_FIREBASE_APP_ID,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
  };
  const vapidKey = env.REACT_APP_FIREBASE_VAPID_KEY;
  if (!vapidKey || Object.values(cfg).some((v) => !v)) return null;
  return {firebase: cfg, vapidKey};
}

/** The browser can do web push at all (secure context + service worker + Push API). */
export function isWebPushSupported(win = typeof window !== "undefined" ? window : undefined) {
  return !!(
    win &&
    win.isSecureContext &&
    "serviceWorker" in win.navigator &&
    "PushManager" in win &&
    "Notification" in win
  );
}

/** Mute list after switching one vehicle's alerts on or off (mirrors Android PushSettingsEdits). */
export function setVehicleEnabled(muted, deviceId, enabled) {
  const current = (muted || []).filter(Boolean);
  if (enabled) return current.filter((d) => d !== deviceId);
  return current.includes(deviceId) ? current : [...current, deviceId];
}

/** Body for POST v1/push/devices. */
export function registrationBody(token, appVersion, timeZone) {
  return {token, platform: "web", appVersion: appVersion || null, timeZone: timeZone || null};
}
